import { useAtom } from 'jotai';
import { upmarketDataAtom } from '@fiverr-private/seller_pages_toolbox';
import { ROLLOUTS } from '../../../../server/middlewares/addRolloutsData/constants';
import { rolloutsAtom } from '../../../atoms';

export const useUpmarketBannerVisibility = () => {
    const [rollouts] = useAtom(rolloutsAtom);
    const [upmarketData] = useAtom(upmarketDataAtom);
    const { segment: upmarketSegment } = upmarketData;

    const isBusinessUnitMP = upmarketSegment?.userBu === 'MP';
    const isBusinessUnitProFit = upmarketSegment?.proBuType === 'ProFit';

    const inDesRollout = rollouts[ROLLOUTS.MARLINS_SELLER_PAGE_DES_BANNER];
    const inMultiRollout = rollouts[ROLLOUTS.MARLINS_SELLER_PAGE_MULTI_BANNER];

    return {
        withDesBanner: inDesRollout && isBusinessUnitMP && !isBusinessUnitProFit,
        withMultiBanner: inMultiRollout && isBusinessUnitMP && isBusinessUnitProFit,
    };
};
